/*
 * Always-visible scroll indicator for the tabs inside the product pane (ticket 3e37c862).
 * The tab content is capped at 25rem and scrolls; the native scrollbar is hidden in CSS because
 * overlay scrollbars (macOS, iOS) only appear while scrolling. This draws a thin accent track and
 * thumb beside the content of an OPEN tab whose content overflows, and keeps it in sync.
 */
(function () {
  function setup(content) {
    if (content.dataset.paneScroll) return;
    content.dataset.paneScroll = '1';
    var details = content.closest('details');
    if (!details) return;
    var track = document.createElement('span');
    track.className = 'pane-tab-scroll';
    track.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    thumb.className = 'pane-tab-scroll__thumb';
    track.appendChild(thumb);
    details.appendChild(track);

    function update() {
      var overflow = content.scrollHeight - content.clientHeight;
      if (!details.open || overflow <= 1) {
        track.hidden = true;
        return;
      }
      track.hidden = false;
      var h = content.clientHeight;
      var thumbH = Math.max(24, Math.round((h * h) / content.scrollHeight));
      track.style.top = content.offsetTop + 'px';
      track.style.height = h + 'px';
      thumb.style.height = thumbH + 'px';
      thumb.style.transform = 'translateY(' + Math.round((content.scrollTop / overflow) * (h - thumbH)) + 'px)';
    }

    content.addEventListener('scroll', update, { passive: true });
    details.addEventListener('toggle', function () { requestAnimationFrame(update); });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(content);
    update();
  }

  function init() {
    document.querySelectorAll('.product__info-container .product__accordion .accordion__content').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
